import axios from "axios";

const userCommonService = axios.create({
    baseURL: process.env.VUE_APP_TMS_SERVER,
    timeout: 30000,
    withCredentials: true
});
userCommonService.defaults.headers['Product'] = 'vsp';

userCommonService.interceptors.request.use(res => {
    res.headers["token"] = JSON.parse(localStorage.getItem("USER")) ? JSON.parse(localStorage.getItem("USER")).token : '';
    return res;
})

userCommonService.interceptors.response.use(
    response => {
        if (response.data.errCode === 1) {
            window.$vm.$Message.error(response.data.errMsg);
            return Promise.reject(response.data);
        }

        return response.data;
    },

    error => {
        window.$vm.$Message.error(error.response.data.errMsg);
        return Promise.reject(error)
    }
);

export default {
    //获取用户信息  
    getUserInfoLogin() {
        return userCommonService.get(`/clientUser/v2/userLogin`);
    },
    // 获取新增学生excel模板
    downloadTemplateExcel() {
        return userCommonService.get(`/Experiment/downloadTemplateExcel`, {
            responseType: 'arraybuffer',
        });
    },
    //导入高校学生名单 
    uploadExperimentStudent(schoolId, formData) {
        return userCommonService.post(`/Experiment/uploadExperimentStudent/${schoolId}`, formData);
    },
    //禁用老师  
    disableTeacher(params) {
        return userCommonService.post(`/teacherMgr/updateTeacherStatus/${params.schoolId}/${params.teacherId}/${params.status}`);
    },
    //禁用学生 
    disableStudent(params) {
        return userCommonService.post(`/studentMgr/updateStudentStatus/${params.schoolId}/${params.studentId }/${params.status}`);
    },
    //设为管理员
    updateTeacherRole(params) {
        return userCommonService.post(`/teacherMgr/updateTeacherRole/${params.teacherId}/${params.role}`);
    },
};